/**
 * TAG TOKENS
 *
 * Custom additions are marked with "Custom" comments below.
 */
import { nbxVar as v } from '../../../tokens/generated/nbx-tokens.js';
import { SEMANTIC, type SemanticTokens } from '../semantic.js';

export function createTagTokens(s: SemanticTokens) {
  return {
    /** Base spacing for tags */
    base: {
      paddingX: v('tag.base.padding-x'), // --tag-base-padding-x: var(--spacing-8)
      paddingY: v('tag.base.padding-y'), // --tag-base-padding-y: var(--spacing-8)
      gap: v('tag.base.gap'), // --tag-base-gap: var(--spacing-8)
      radius: v('tag.base.radius'), // --tag-base-radius: var(--radius-4)
      fontSize: s.typography.fontSize.xs, // --tag-base-font-size
      fontWeight: s.typography.fontWeight.bold, // --tag-base-font-weight
      fontFamily: s.typography.fontFamily.base, // --tag-base-font-family
      height: '1.5rem', // --tag-base-height
      iconSize: s.iconSizes.base, // --tag-base-icon-size
      lineHeight: s.typography.lineHeight.base, // --tag-base-line-height
    },
    emphasis: {
      fontSize: s.typography.fontSize.base, // --tag-emphasis-font-size
      lineHeight: s.typography.lineHeight.xl, // --tag-emphasis-line-height
      fontWeight: s.typography.fontWeight.semibold,
    },
    /** Compact variant for tags that sit inside a dense surface, e.g. a calendar night. */
    compact: {
      paddingX: s.layout.gap.xs, // --tag-compact-padding-x: var(--spacing-4)
      fontSize: s.typography.fontSize.xs,
      lineHeight: s.typography.lineHeight.base,
      height: '1.125rem', // --tag-compact-height
    },
    /** Brand/solid tag */
    brand: {
      fg: v('tag.brand.solid.fg'), // --tag-brand-solid-fg: var(--text-primary)
      bg: v('tag.brand.solid.bg'), // --tag-brand-solid-bg: var(--color-rentals-50)
    },
    /** Status tags */
    status: {
      success: {
        fg: v('tag.status.success.fg'), // --tag-status-success-fg: var(--states-success-fg)
        bg: v('tag.status.success.bg'), // --tag-status-success-bg: var(--states-success-bg)
      },
      danger: {
        fg: v('tag.status.danger.fg'), // --tag-status-error-fg: var(--states-danger-fg)
        bg: v('tag.status.danger.bg'), // --tag-status-error-bg: var(--states-danger-bg)
      },
      warning: {
        fg: v('tag.status.warning.fg'), // --tag-status-warning-fg: var(--states-warning-fg)
        bg: v('tag.status.warning.bg'), // --tag-status-warning-bg: var(--states-warning-bg)
      },
      neutralInfo: {
        fg: v('tag.status.info.fg'), // --tag-status-neutral-info-fg: var(--states-info-fg)
        bg: v('tag.status.info.bg'), // --tag-status-neutral-info-bg: var(--states-info-bg)
      },
    },

    // ──── Custom tokens ────

    /** Secondary tag (neutral) */
    secondary: {
      fg: s.text.secondary, // --tag-secondary-fg: var(--text-secondary)
      bg: s.surface.canvas, // --tag-secondary-bg: var(--surface-canvas)
    },
  };
}
export const tagTokens = createTagTokens(SEMANTIC);
